import styled from 'styled-components'

interface IExporterExportFormStyledProps {}

export const ExporterExportFormStyled = styled.div<IExporterExportFormStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
